module.exports = __webpack_public_path__ + "img/button-scorpion.97700574.jpg";